<template>
    <page-message>
        <template #header>{{t('header')}}</template>
    </page-message>
</template>

<script>

    import mixin_view from "@/mixins/view";
    import {encode} from "@/helpers/base64";

    import PageMessage from "@/components/page/PageMessage";

    export default {
        name: "ViewsErrors404",
        mixins: [mixin_view],
        components: {
            PageMessage
        },
        data() {

            return {
                t_path: "views.errors.404"
            }
        },
        beforeMount() {

            if ("undefined" === typeof this.$route.name) {

                this.$platform.post(
                    "/api/v2/frontend/log",
                    encode(
                        JSON.stringify({
                            type: "page_not_found",
                            source: "mktportal",
                            details: {
                                path: this.$route.fullPath,
                                referrer: document.referrer
                            }
                        })
                    ),
                    {
                        headers: {
                            "X-Content-Transfer-Encoding": "base64",
                            "Content-Type": "application/json"
                        },
                    }
                );
            }
        }
    }
</script>